// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'ladda/dist/ladda-themeless.min.css';
import VModal from 'vue-js-modal';
import Vue from 'vue';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as Amplitude from '@amplitude/node';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import GoogleAuth from './google_oAuth';
import './plugins/vuetify-money';

Vue.prototype.$amplitude_client = Amplitude.init(
  'c5f40607c3922d1376239f870d766569'
);

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$gAuth = new GoogleAuth();

const EN = require('./lang/en');
// socket io
// import * as io from "socket.io-client";

// eslint-disable-next-line import/order
const Lang = require('vue-lang');

const locales = {
  en: EN,
};

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.use(Lang, { lang: 'en', locales });

Chart.plugins.unregister(ChartDataLabels);

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://bab8a45ce18b4f5e909e71968afe4335@o4504328532066304.ingest.sentry.io/4504328532066304',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['hirefly.com', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 10%
    // of transactions for performance monitoring.
    // Adjust as necessary to stay below quota.
    tracesSampleRate: 0.1,

    environment: process.env.NODE_ENV,

    // Enable performance profiling of all components,
    // instead of just App.vue.
    trackComponents: true,
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  components: { App },
  template: '<App/>',
});
